/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import { GhostButton, PrimaryButton } from '../../../../styles/ui/Button';

import Modal from '../../../../components/Modal/Modal';

// =============================================================================
// RescheduleConfirmModal — confirmação de reagendamento a partir do board.
//
// O reagendamento deixou de ser um evento/endpoint dedicado (RESCHEDULED e o
// POST /reschedule foram escondidos). Após marcar o item como "Não realizado",
// o operador pode reagendá-lo criando um NOVO item avulso (mesmo order_number,
// nova data), aberto em OUTRA GUIA na tela de criação manual. O rastreio da
// cadeia passa a ser por order_number (refactor de backend futuro) — aqui é só
// o disparo do fluxo. O operador confirma cliente/endereço/data na tela nova.
//
// ⚠️ Os botões NÃO usam as classes `hf-btn` do board: o Modal é portaled para
// fora do container `.hf`, onde as CSS custom properties (--my-blue, --ink…)
// não existem — o primário ficaria com texto branco invisível. Por isso cores
// explícitas via styled-components (padrão dos demais modais do módulo).
// =============================================================================

export default function RescheduleConfirmModal({
   isOpen,
   onClose,
   orderNumber = null,
   onConfirm,
}) {
   if (!isOpen) return null;

   return (
      <Modal
         isOpen={isOpen}
         onClose={onClose}
         title="Reagendar pedido"
         maxWidth="440px"
         footer={
            <>
               <GhostButton type="button" onClick={onClose}>
                  Agora não
               </GhostButton>
               <PrimaryButton type="button" onClick={onConfirm}>
                  Reagendar
               </PrimaryButton>
            </>
         }
      >
         <div style={{ fontSize: 14, lineHeight: 1.5 }}>
            O pedido <strong>{orderNumber || '—'}</strong> foi marcado como{' '}
            <strong>não realizado</strong>. Deseja reagendá-lo?
            <br />
            <br />
            Abriremos a tela de criação de um novo item avulso em{' '}
            <strong>outra guia</strong>, já com o número do pedido preenchido.
            Confirme o cliente, o endereço e a nova data por lá.
         </div>
      </Modal>
   );
}

RescheduleConfirmModal.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   onClose: PropTypes.func.isRequired,
   orderNumber: PropTypes.string,
   onConfirm: PropTypes.func.isRequired,
};
